import { and, minLength, helpers, maxLength } from '@vuelidate/validators'

export const ValidatorPassword = and(minLength(10), maxLength(35), helpers.regex(/\d/), helpers.regex(/[A-Z]/), helpers.regex(/[a-z]/))
